<template>
  <div class="standard-levels-list">
    <v-list two-line subheader class="scrollable-levels">
      
      <div v-for="(level, i) in standardLevels" :key="i">
       <div v-if="i === 10">
          <InFeedAdsense 
            data-ad-layout-key="-fb+5w+4e-db+86"
            data-ad-client="ca-pub-8053105940003886"
            data-ad-slot="4604334505"
            data-ad-format="fluid">
          </InFeedAdsense>
          <v-divider></v-divider>
        </div>
        
        <div v-if="i === 25">
          <InFeedAdsense
            data-ad-layout-key="-fb+5w+4e-db+86"
            data-ad-client="ca-pub-8053105940003886"
            data-ad-slot="2106163678"
            data-ad-format="fluid">
          </InFeedAdsense>
          <v-divider></v-divider>
        </div>
        
        <div v-if="i === 40">
          <InFeedAdsense
            data-ad-layout-key="-fb+5w+4e-db+86"
            data-ad-client="ca-pub-8053105940003886"
            data-ad-slot="6975346978"
            data-ad-format="fluid">
          </InFeedAdsense>
          <v-divider></v-divider> 
        </div>
        <v-list-tile
          avatar
          @click="showLevelInfo(level, i)"
          :class="{'grey':levelSelected === level.id, 'lighten-3':levelSelected === level.id}"
        >
          <v-list-tile-avatar>
            <span class="headline">{{ level.id }}</span>
          </v-list-tile-avatar>

          <v-list-tile-content>
            <v-list-tile-title>{{ level.title }}</v-list-tile-title>
            <v-list-tile-sub-title>{{ level.shortDescription }}</v-list-tile-sub-title>
          </v-list-tile-content>
           <!-- Show only scores if logged in -->
          <v-list-tile-action v-show="loggedIn">
            <v-list-tile-action-text>{{scores[i]}}%</v-list-tile-action-text>
            <v-progress-circular :value="scores[i]" color="green"></v-progress-circular>
          </v-list-tile-action>
          <v-list-tile-action v-show="!loggedIn">
            <!-- <v-list-tile-action-text>N/A</v-list-tile-action-text> -->
            <v-tooltip left>
              <v-icon slot="activator">report_problem</v-icon>
              <span>N/A - Please log in to see your saved scores</span>
            </v-tooltip>
          </v-list-tile-action>

          <!-- This icon is only shown on smaller screens -->
           <v-icon @click="toggleDescriptionList" v-if="breakpoint.xsOnly" large class="ml-2">chevron_right</v-icon>
        </v-list-tile>
        <v-divider></v-divider>
      </div>
    </v-list>
  </div>
</template>

<script>
export default {
  name: "standardLevelsList",
  data() {
    return {
      levelSelected: null
    };
  },
  methods: {
    showLevelInfo(level, i) {
      // Set the selected level to highlight it
      this.levelSelected = level.id;
      this.$store.dispatch("setCurrentlySelectedLevel", {
        type: "standard",
        level: level,
        index: i
      });

    },
    toggleDescriptionList() {
      this.$store.dispatch('setShowExerciseDescription', true);
      this.$store.dispatch('setShowExerciseList', false);
    }
  },
  computed: {
    standardLevels() {
      return this.$store.getters.getExerciseList;
    },
    scores() {
      return this.$store.getters.getStandardScores;
    },
    breakpoint() {
      return this.$vuetify.breakpoint;
    },
    showExerciseDescription() {
      return this.$store.getters.getShowExerciseDescription;
    },
    showExerciseList() {
      return this.$store.getters.getShowExerciseList;
    },
    loggedIn() {
      return this.$store.getters.getUser;
    }
  },
  created() {
      this.levelSelected = this.$store.getters.getCurrentlySelectedLevel.id;
  }
};
</script>

<style>


.standard-levels-list .scrollable-levels {
  /* height: calc(100vh - 84px); */
  height: calc(calc(var(--vh, 1vh) * 100) - 84px)!important;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

@media screen and (max-width: 600px) {
  .user-levels-list .scrollable-levels {
    /* height: calc(100vh - 154px); */
    height: calc(calc(var(--vh, 1vh) * 100) - 154px)!important;
  }
}
</style>
